export default __webpack_public_path__ + "static/media/PPI-steps-006.30d1a288.jpg";